import { default as ReferralPage } from "../components/Referral";

const Referral = () => {
  return <ReferralPage />;
};

export default Referral;
